import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, HeartIcon, XIcon } from 'lucide-react';
const randomHearts = () => Math.floor(Math.random() * 40) + 5;
type Comment = {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  date: string;
  text: string;
  hearts: number;
  isLiked: boolean;
};
const INITIAL_COMMENTS: Comment[] = [{
  id: '1',
  name: 'Valu 🧋',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  rating: 5,
  date: 'Hace 2 horas',
  text: 'amigaaaa lo compré ayer a la noche y ya hice las perlas clasicas!! me salieron re bien, no lo puedo creer jajaja 😭🧋',
  hearts: 24,
  isLiked: false
}, {
  id: '2',
  name: 'Cami Soto',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
  rating: 5,
  date: 'Hace 5 horas',
  text: 'dudé banda en comprarlo pero la verdad? re vale la pena. la parte de costos me salvó la vida literal, ya se cuanto gano x vaso 💰',
  hearts: 18,
  isLiked: false
}, {
  id: '3',
  name: 'Martina F.',
  avatar: 'https://randomuser.me/api/portraits/women/50.jpg',
  rating: 4,
  date: 'Hace 1 día',
  text: 'esta bueno! me faltaron mas recetas con matcha pero bueno, lo demas esta muy completo. igual lo recomiendo eh',
  hearts: 12,
  isLiked: false
}, {
  id: '4',
  name: 'Sofi ✨',
  avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
  rating: 5,
  date: 'Hace 1 día',
  text: 'LO AMEEEE. lo lei todo de corrido jaja. ya estoy armando el menu para mi local, graciasss!! 🙌',
  hearts: 35,
  isLiked: false
}, {
  id: '5',
  name: 'Lu Mendoza',
  avatar: 'https://randomuser.me/api/portraits/women/55.jpg',
  rating: 5,
  date: 'Hace 2 días',
  text: 'las sodas italianas con boba son un GOLAZO. las vendo en ferias y la gente hace fila, posta 🔥',
  hearts: 42,
  isLiked: false
}, {
  id: '6',
  name: 'Juli 💜',
  avatar: 'https://randomuser.me/api/portraits/women/12.jpg',
  rating: 5,
  date: 'Hace 2 días',
  text: 'recuperé lo q pagué en el primer finde vendiendo en la plaza de mi barrio jajaj no lo puedo creer',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '7',
  name: 'Diego M.',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  rating: 5,
  date: 'Hace 3 días',
  text: 'lo sumé a mi cafetería y las ventas subieron banda. las recetas estan muy bien explicadas 👌',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '8',
  name: 'Flor 🌸',
  avatar: 'https://randomuser.me/api/portraits/women/71.jpg',
  rating: 5,
  date: 'Hace 3 días',
  text: 'la parte de costos era lo q mas miedo me daba y ahora la tengo re clara!! gracias x hacerlo tan facil de entender ❤️',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '9',
  name: 'Pau Herrera',
  avatar: 'https://randomuser.me/api/portraits/women/90.jpg',
  rating: 4,
  date: 'Hace 4 días',
  text: 'buenisimo el contenido. algunos ingredientes me costó conseguirlos aca en mi ciudad pero el manual da alternativas asi q todo bien',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '10',
  name: 'Mica 🐱',
  avatar: 'https://placekitten.com/151/151',
  rating: 5,
  date: 'Hace 4 días',
  text: 'las perlas de sabores son UNA LOCURA la gente enloquece jajaj mis ventas x instagram se triplicaron 📈🧋',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '11',
  name: 'Anto Ruiz',
  avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
  rating: 5,
  date: 'Hace 5 días',
  text: 'no sabia NADA de bubble tea y con esto arranqué de cero. re bien explicado todo',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '12',
  name: 'Caro 🍵',
  avatar: 'https://randomuser.me/api/portraits/women/47.jpg',
  rating: 5,
  date: 'Hace 5 días',
  text: 'el mejor ebook q compré en mi vida y mira q compré varios jaja. directo al grano, nada de relleno 👏',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '13',
  name: 'Mari López',
  avatar: 'https://randomuser.me/api/portraits/women/85.jpg',
  rating: 5,
  date: 'Hace 6 días',
  text: 'ya armé todo el menú!! tengo como 15 sabores distintos gracias a las recetas. mil graciasss 🙏',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '14',
  name: 'Agus P.',
  avatar: 'https://randomuser.me/api/portraits/women/63.jpg',
  rating: 4,
  date: 'Hace 1 sem',
  text: 're util la info, me sirvió para estandarizar todo y no andar adivinando las cantidades jaj',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '15',
  name: 'Dani ☀️',
  avatar: 'https://randomuser.me/api/portraits/women/19.jpg',
  rating: 5,
  date: 'Hace 1 sem',
  text: 'x este precio es un REGALO. tiene mas info q cursos q salen 10 veces mas caros, lo juro',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '16',
  name: 'Vicky Paz',
  avatar: 'https://randomuser.me/api/portraits/women/37.jpg',
  rating: 5,
  date: 'Hace 1 sem',
  text: 'me dio la confianza q necesitaba para largarme. ya hice mi primer batch y salió PERFECTO 😍',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '17',
  name: 'Tomi N.',
  avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
  rating: 5,
  date: 'Hace 1 sem',
  text: 'lo apliqué en mi cafe y fue un éxito. la gente pide bubble tea todos los dias ahora jaja',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '18',
  name: 'Ro 🌺',
  avatar: 'https://randomuser.me/api/portraits/women/52.jpg',
  rating: 5,
  date: 'Hace 2 sem',
  text: 'las sodas italianas son lo q mas vendo!! la gente las pide x el color jajaj son hermosas y ricas 🤤',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '19',
  name: 'Jose Ríos',
  avatar: 'https://randomuser.me/api/portraits/women/76.jpg',
  rating: 4,
  date: 'Hace 2 sem',
  text: 'muy bueno, tuve q adaptar un par de medidas xq aca se consiguen cosas distintas pero la base esta excelente',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '20',
  name: 'Lou ✿',
  avatar: 'https://randomuser.me/api/portraits/women/41.jpg',
  rating: 5,
  date: 'Hace 2 sem',
  text: 'no sabia NADA y ahora mis amigas me piden q les haga bubble tea todo el tiempo jajaj me siento una pro 😂🧋',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '21',
  name: 'Pili D.',
  avatar: 'https://placekitten.com/149/149',
  rating: 5,
  date: 'Hace 2 sem',
  text: 'el diseño del ebook es hermoso y la info es ORO. se nota q saben del tema',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '22',
  name: 'Guille V.',
  avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
  rating: 5,
  date: 'Hace 3 sem',
  text: 'me ahorré MESES de prueba y error. ya estoy vendiendo y la gente repite ❤️‍🔥',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '23',
  name: 'Cande 🍑',
  avatar: 'https://randomuser.me/api/portraits/women/15.jpg',
  rating: 5,
  date: 'Hace 3 sem',
  text: 'las recetas de té frutal son RIQUISIMASSS a mis clientes les re copan, piden siempre',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '24',
  name: 'Mili Cruz',
  avatar: 'https://randomuser.me/api/portraits/women/59.jpg',
  rating: 4,
  date: 'Hace 3 sem',
  text: 'todo bien explicado, la tabla de costos me re sirvió. lo unico q le agregaría son mas fotos del paso a paso',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '25',
  name: 'Barbi 💫',
  avatar: 'https://randomuser.me/api/portraits/women/82.jpg',
  rating: 5,
  date: 'Hace 1 mes',
  text: 'se lo recomendé a mi hermana y ya estamos las dos vendiendo jajaj. excelente inversión',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '26',
  name: 'Maca Gil',
  avatar: 'https://randomuser.me/api/portraits/women/8.jpg',
  rating: 5,
  date: 'Hace 1 mes',
  text: 'las perlas me salen perfectas!! antes las compraba hechas y ahora las hago yo, me ahorro un montón 💪',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '27',
  name: 'Emi 🧋',
  avatar: 'https://randomuser.me/api/portraits/women/95.jpg',
  rating: 5,
  date: 'Hace 1 mes',
  text: 'claro, al pie y sin vueltas. justo lo q necesitaba. GRACIAS',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '28',
  name: 'Nico R.',
  avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
  rating: 5,
  date: 'Hace 1 mes',
  text: 'sumé boba a mi local de comida y explotó todo. la gente lo pide mas q los jugos normales',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '29',
  name: 'Delfi 🌙',
  avatar: 'https://randomuser.me/api/portraits/women/31.jpg',
  rating: 4,
  date: 'Hace 1 mes',
  text: 'buena info, me ayudó a organizar las compras de insumos y no comprar de mas',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '30',
  name: 'Rena V.',
  avatar: 'https://randomuser.me/api/portraits/women/74.jpg',
  rating: 5,
  date: 'Hace 2 meses',
  text: 'las mejores recetasss!! mis amigas estan fascinadas, me piden q les venda siempre jajaj 😂',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '31',
  name: 'Zoe 🐈',
  avatar: 'https://placekitten.com/152/152',
  rating: 5,
  date: 'Hace 2 meses',
  text: 're completo. la seccion de costos es lo mejor, te cambia la cabeza',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '32',
  name: 'Alma C.',
  avatar: 'https://randomuser.me/api/portraits/women/3.jpg',
  rating: 5,
  date: 'Hace 2 meses',
  text: 'ya estoy planeando mi carrito de bubble tea para las ferias de verano!! esto me dio todo lo q necesitaba 🛒🧋',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '33',
  name: 'Mía A.',
  avatar: 'https://randomuser.me/api/portraits/women/49.jpg',
  rating: 5,
  date: 'Hace 3 meses',
  text: 'lo recomiendo 100%. si estas dudando COMPRALO, no te vas a arrepentir',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '34',
  name: 'Oli Fuentes',
  avatar: 'https://randomuser.me/api/portraits/women/66.jpg',
  rating: 4,
  date: 'Hace 3 meses',
  text: 'buen contenido, me sirvió bastante. ojalá saquen una parte 2 con mas recetas!',
  hearts: randomHearts(),
  isLiked: false
}, {
  id: '35',
  name: 'Emma 🌈',
  avatar: 'https://randomuser.me/api/portraits/women/21.jpg',
  rating: 5,
  date: 'Hace 3 meses',
  text: 'mi emprendimiento va re bien gracias a esto!! ya tengo clientas fijas q me compran todas las semanas 🥹❤️',
  hearts: randomHearts(),
  isLiked: false
}];
export function CommentsSection() {
  const [comments, setComments] = useState<Comment[]>(INITIAL_COMMENTS);
  const [visibleCount, setVisibleCount] = useState(5);
  const [newCommentText, setNewCommentText] = useState('');
  const [newCommentRating, setNewCommentRating] = useState(5);
  const [showModal, setShowModal] = useState(false);
  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, comments.length));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newCommentText.trim()) return;
    const newComment: Comment = {
      id: Date.now().toString(),
      name: 'Tú',
      avatar: 'https://ui-avatars.com/api/?name=Tu&background=2D5A27&color=fff',
      rating: newCommentRating,
      date: 'Hace un momento',
      text: newCommentText,
      hearts: 0,
      isLiked: false
    };
    setComments([newComment, ...comments]);
    setNewCommentText('');
    setNewCommentRating(5);
    setShowModal(true);
    // Auto-hide modal after 3 seconds
    setTimeout(() => {
      setShowModal(false);
    }, 3000);
  };
  const toggleHeart = (id: string) => {
    setComments(comments.map(comment => {
      if (comment.id === id) {
        return {
          ...comment,
          isLiked: !comment.isLiked,
          hearts: comment.isLiked ? comment.hearts - 1 : comment.hearts + 1
        };
      }
      return comment;
    }));
  };
  return <section className="bg-[#FDFBF7] py-16 border-t border-gray-200" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <h2 className="text-2xl md:text-3xl font-extrabold uppercase text-[#2D5A27] font-sans mb-8 text-center" data-id="element-49">
          Lo que dicen nuestros alumnos
        </h2>

        {/* Input Form */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-10" data-id="element-50">
          <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-51">
            Deja tu opinión
          </h3>
          <form onSubmit={handleSubmit} data-id="element-52">
            <div className="mb-4" data-id="element-53">
              <div className="flex items-center gap-1 mb-2" data-id="element-54">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setNewCommentRating(star)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-55">
                    <StarIcon className={`w-8 h-8 ${star <= newCommentRating ? 'fill-[#FFD700] text-[#FFD700]' : 'text-gray-300'}`} data-id="element-56" />
                  </button>)}
              </div>
              <textarea value={newCommentText} onChange={e => setNewCommentText(e.target.value)} placeholder="¿Qué te pareció el eBook?" className="w-full border border-gray-300 rounded-xl p-4 focus:ring-2 focus:ring-[#2D5A27] focus:border-transparent outline-none resize-none h-24 font-sans text-gray-700" required data-id="element-57" />
            </div>
            <div className="flex justify-end" data-id="element-58">
              <button type="submit" className="bg-[#2D5A27] hover:bg-[#1e3d1a] text-white font-bold py-2 px-6 rounded-xl transition-colors" data-id="element-59">
                Publicar comentario
              </button>
            </div>
          </form>
        </div>

        {/* Comments List */}
        <div className="space-y-6" data-id="element-60">
          <AnimatePresence data-id="element-61">
            {comments.slice(0, visibleCount).map(comment => <motion.div key={comment.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.3
          }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex gap-4" data-id="element-62">
                <img src={comment.avatar} alt={comment.name} className="w-12 h-12 rounded-full object-cover flex-shrink-0 border border-gray-200" data-id="element-63" />
                <div className="flex-1" data-id="element-64">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-1" data-id="element-65">
                    <h4 className="font-bold text-gray-900" data-id="element-66">{comment.name}</h4>
                    <span className="text-sm text-gray-500" data-id="element-67">
                      {comment.date}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 mb-3" data-id="element-68">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < comment.rating ? 'fill-[#FFD700] text-[#FFD700]' : 'text-gray-300'}`} data-id="element-69" />)}
                  </div>
                  <p className="text-gray-700 leading-relaxed mb-4 font-sans" data-id="element-70">
                    {comment.text}
                  </p>
                  <div className="flex items-center gap-2" data-id="element-71">
                    <button onClick={() => toggleHeart(comment.id)} className="flex items-center gap-1.5 text-sm font-medium transition-colors hover:text-red-500 group" data-id="element-72">
                      <HeartIcon className={`w-5 h-5 transition-transform group-hover:scale-110 ${comment.isLiked ? 'fill-red-500 text-red-500' : 'text-gray-400'}`} data-id="element-73" />
                      <span className={comment.isLiked ? 'text-red-500' : 'text-gray-500'} data-id="element-74">
                        {comment.hearts}
                      </span>
                    </button>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {/* Load More Button */}
        {visibleCount < comments.length && <div className="mt-10 text-center" data-id="element-75">
            <button onClick={handleLoadMore} className="border-2 border-[#2D5A27] text-[#2D5A27] hover:bg-[#2D5A27] hover:text-white font-bold py-3 px-8 rounded-xl transition-colors bg-[#FFFFFF]" data-id="element-76">
              Cargar 5 más
            </button>
            <p className="text-sm text-gray-500 mt-3" data-id="element-77">
              Mostrando {visibleCount} de {comments.length} comentarios
            </p>
          </div>}
      </div>

      {/* Success Modal */}
      <AnimatePresence data-id="element-78">
        {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40 backdrop-blur-sm" data-id="element-79">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-2xl relative" data-id="element-80">
              <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-81">
                <XIcon className="w-5 h-5" data-id="element-82" />
              </button>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-83">
                <StarIcon className="w-8 h-8 text-green-600 fill-green-600" data-id="element-84" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-85">
                ¡Gracias por tu opinión!
              </h3>
              <p className="text-gray-600" data-id="element-86">
                Tu comentario ha sido publicado exitosamente.
              </p>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}